import { TEAM_INVITES_UI_ENABLED } from "@/lib/featureFlags";

export function TeamRoleGuide() {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 text-[12px] text-slate-600 space-y-2">
      <div className="text-[13px] font-semibold text-slate-900">Role guide</div>
      <p><strong>Owner</strong> — full control, billing, role changes, and removals.</p>
      <p><strong>Admin</strong> — {TEAM_INVITES_UI_ENABLED ? "can invite and revoke pending invites." : "full workspace administration."}</p>
      <p><strong>Member</strong> — standard workspace access.</p>
      {TEAM_INVITES_UI_ENABLED ? (
        <p className="text-[11px] text-slate-500 pt-1">
          Invites require Founder plan or above. Only Admin and Member roles can be invited.
        </p>
      ) : (
        <p className="text-[11px] text-slate-500 pt-1">
          Team invites are coming in a future release.
        </p>
      )}
    </div>
  );
}
